import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import PerfDynamicRendering from '@adv-mt/mt-perf-dynamic-rendering'
const TYPES = {
  DEFAULT: 'default',
  GRID: 'grid',
  MOSAIC: 'mosaic'
}

const BORDER_TYPES = {
  DEFAULT: 'default',
  ROUNDED: 'rounded'
}

const BASE_CLASS = 'mt-MediaFigure'
const IMAGES_CLASS = `${BASE_CLASS}-images`
const ITEM_CLASS = `${IMAGES_CLASS}Item`
const CAPTION_CLASS = `${BASE_CLASS}-caption`

const MediaFigure = ({
  dynamicRenderingProps,
  images = [],
  caption,
  type = TYPES.DEFAULT,
  borderType = BORDER_TYPES.DEFAULT
}) => {
  const isDefault = type === TYPES.DEFAULT
  const isGrid = type === TYPES.GRID
  const isMosaic = type === TYPES.MOSAIC
  const isRounded = borderType === BORDER_TYPES.ROUNDED

  const hasMultipleImages = images.length > 1

  const imagesClassName = cx(IMAGES_CLASS, {
    [`${IMAGES_CLASS}--column`]: hasMultipleImages && isDefault,
    [`${IMAGES_CLASS}--grid`]: hasMultipleImages && isGrid,
    [`${IMAGES_CLASS}--mosaic`]: hasMultipleImages && isMosaic
  })

  const itemClassName = cx(ITEM_CLASS, {
    [`${ITEM_CLASS}--rounded`]: isRounded
  })

  const figureTree = () => (
    <figure className={BASE_CLASS} role="group">
      <div className={imagesClassName}>
        {images.map(image => (
          <figure className={itemClassName}>
            <AtomImage src={image.src} alt={caption} />
          </figure>
        ))}
      </div>
      <figcaption className={CAPTION_CLASS}>{caption}</figcaption>
    </figure>
  )

  return dynamicRenderingProps ? (
    <PerfDynamicRendering {...dynamicRenderingProps}>{figureTree()}</PerfDynamicRendering>
  ) : (
    figureTree()
  )
}

MediaFigure.displayName = 'MediaFigure'
MediaFigure.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({src: PropTypes.string.isRequired})),
  caption: PropTypes.string,
  type: PropTypes.oneOfType(Object.values(TYPES)),
  borderType: PropTypes.oneOfType(Object.values(BORDER_TYPES)),
  dynamicRenderingProps: PropTypes.object
}

export default MediaFigure

export const mediaFigureTypes = TYPES
export const mediaFigureBorderTypes = BORDER_TYPES
